import React, { useEffect, useRef } from "react";
import { useParticipant } from "@videosdk.live/react-sdk";

const AudioParticipantView = ({ participantId }) => {
  const { micStream, micOn, isLocal } = useParticipant(participantId);
  const micRef = useRef(null);

  useEffect(() => {
    if (micRef.current) {
      if (micOn && micStream) {
        const mediaStream = new MediaStream();
        mediaStream.addTrack(micStream.track);

        micRef.current.srcObject = mediaStream;
        micRef.current
          .play()
          .catch((error) => console.error("micRef play failed", error));
      } else {
        micRef.current.srcObject = null;
      }
    }
  }, [micStream, micOn]);

  return (
    <audio ref={micRef} autoPlay playsInline muted={isLocal} />
  );
};

export default AudioParticipantView;
